import { render, staticRenderFns } from "./TaskGroupsPage.vue?vue&type=template&id=d6b451da"
import script from "./TaskGroupsPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./TaskGroupsPage.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/PortfolioWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d6b451da')) {
      api.createRecord('d6b451da', component.options)
    } else {
      api.reload('d6b451da', component.options)
    }
    module.hot.accept("./TaskGroupsPage.vue?vue&type=template&id=d6b451da", function () {
      api.rerender('d6b451da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Pages/TaskManagement/Components/TaskGroupsPage.vue"
export default component.exports